export default "__VITE_ASSET__B_8z8kcf__"